export default __webpack_public_path__ + "static/media/login.e85be385.png";